<div class="right-panel configSettings h-100">
  <!-- Search bar -->
  <div class="d-flex">
    <input
      type="text"
      title="Search by Section or Name"
      placeholder="Search By Section/Name"
      class="search"
      [formControl]="searchTerm"
    />
    <button
      *ngIf="isMonitor == false"
      type="button"
      class="actionBtn"
      (click)="addServiceBroadcastMessage()"
      placement="top auto"
      container="body"
      triggers="hover"
      ngbTooltip="Send broadcast message (VDI VMs Only)"
    >
      <span class="bi bi-broadcast"></span>
    </button>
    <!-- Added email button -->
    <button
      *ngIf="isMonitor == false"
      type="button"
      class="actionBtn"
      (click)="onSendTestEmailClick()"
      placement="top auto"
      container="body"
      triggers="hover"
      ngbTooltip="Test Email Functionality"
    >
      <span class="bi bi-envelope-arrow-up"></span>
    </button>
    <div *ngIf="isSendingEmail" class="email-sending-animation">
      <div class="email-envelope">
        <div class="email-paper"></div>
      </div>
      <div class="email-sending-text">Sending Test Email...</div>
    </div>
    <div
      *ngIf="isMonitor == false"
      class="newDir h-100"
      ngbDropdown
      container="body"
    >
      <button
        type="button"
        class="actionBtn"
        ngbDropdownToggle
        triggers="hover"
      >
        <i class="bi bi-gear"></i>
      </button>
      <div ngbDropdownMenu>
        <button
          ngbDropdownItem
          title="Update authentication type and values"
          (click)="updateAuthenticationConfiguration()"
        >
          Update Authentication
        </button>
        <!--<button
          ngbDropdownItem
          title="Change login page UI"
          (click)="updateLogInPageUIConfiguration()"
        >
          Update Login Page UI
        </button>-->
      </div>
    </div>
  </div>
  <!--setting panel-->
  <div class="settingsPanel">
    <ng-container *ngIf="filteredParameters">
      <app-config-section
        #configComp
        [configEntities]="filteredParameters"
      ></app-config-section>
    </ng-container>
  </div>
  <div *ngIf="isMonitor == false" class="bottom-panel">
    <button
      class="default-btn"
      type="button"
      title="Save the changes."
      (click)="onSave()"
    >
      <span
        class="bi bi-save"
        aria-hidden="True"
        style="margin-right: 10px"
      ></span
      >Save
    </button>
  </div>
</div>
